import { useSuspenseInfiniteQuery } from '@tanstack/react-query';

import { useQueryKeys } from '@/shared/hooks/use-query-keys';
import { FetchCreatorsInSavedList } from '..';

const LIMIT = 20;

export const useCreatorsListFromSavedList = (listId: string) => {
  const queryKeys = useQueryKeys();
  return useSuspenseInfiniteQuery({
    queryKey: queryKeys.savedCreatorsList.detail(listId),
    queryFn: ({ signal, pageParam }) => FetchCreatorsInSavedList(listId, pageParam, signal),
    getNextPageParam: (lastPage) => {
      if (lastPage.total_pages <= lastPage.page) return null;
      return {
        page: lastPage.page + 1,
        limit: LIMIT,
      };
    },
    initialPageParam: null as null | {
      page: number;
      limit: number;
    },
  });
};
